/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainRecruiterNewDriverDriverSegmentEnum {
  'RecruiterNewDriverDriverSegmentNew' = 'new',
  'RecruiterNewDriverDriverSegmentReactivated' = 'reactivated',
}

export type DomainRecruiterNewDriverDriverSegment = DomainRecruiterNewDriverDriverSegmentEnum